import { NUMBER } from "./app-constants";
import { getYearInBackOrder } from "../utils/helpers/checkout-util";

export const yearData = getYearInBackOrder(parseInt(new Date().getFullYear()), 0, NUMBER.TWENTY_FIVE);
export const TABS = {
    registration: {
        heading: "Rego",
        inputPlaceHolder: "ENTER REGO",
        searchPlaceholder: "State",
        inputKey: "regNo",
        searchKey: "state",
        searchData: [],
        key: "registration"
    },
    vehicle: {
        heading: "VIN",
        inputPlaceHolder: "Enter VIN",
        searchPlaceholder: "Build year",
        inputKey: "vin",
        searchKey: "year",
        searchData: yearData,
        key: "vehicle"
    }
};

export const SCREEN_STATES = {
    ENTER_DETAILS: "ENTER_DETAILS",
    SEARCHING_REGO_DETAILS: "SEARCHING_REGO_DETAILS",
    VARIANT_SELECTION: "VARIANT_SELECTION",
    VEHICLE_FOUND: "VEHICLE_FOUND",
    VEHICLE_NOT_FOUND: "VEHICLE_NOT_FOUND",
    REPORT_FOUND: "REPORT_FOUND"
};

export const SERVICE_REPORT_STATUS = {
    INTERIM_GENERATED: "INTERIM_GENERATED",
    GENERATED: "GENERATED",
    IN_PROGRESS: "IN_PROGRESS",
    FALIED: "FAILED"
};

export const getCarDetails = (variant) => {
    const {year = "", make = "", model = "", variant: carVariant = "", transmission = "", body = "", fuel = ""} = variant || {};
    const carName = `${year || ""} ${make || ""} ${model || ""}`;
    const carDetails = `${carVariant || ""} | ${transmission || ""} | ${body || ""} | ${fuel || ""}`;
    return {
        carName,
        carDetails
    };
};

export const CAR_HISTORY_CARDS_TYPE = {
    SELL_CARD: "SELL/EXCHANGE CAR",
    FINANCE: "CAR FINANCE"
};
